import { configureStore } from "@reduxjs/toolkit";

import initializeAppReducer from "./initializeAppSlice";
import searchBarReducer from "./searchBarSlice";

export default configureStore({
  reducer: {
    initializeApp: initializeAppReducer,
    searchBar: searchBarReducer,
  },
});
